export const RegionShortLabel = {
  US: 'US',
  CA: 'CA',
  GB: 'UK',
  Global: 'INTL',
} as const;

const RegionLabelOrder = ['US', 'CA', 'GB', 'Global'];
export const getSortedRegions = (regionSlugs: string[]) => {
  return [...regionSlugs].sort(
    (a, b) => RegionLabelOrder.indexOf(a) - RegionLabelOrder.indexOf(b),
  );
};
